<template>
  <v-layout class="collections-container">
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" sm="10" md="9" lg="8" class="py-0">
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="!hover ? 0 : 0" class="height-100">
              <v-card-title>
                <span>Colecciones</span>
                <v-spacer />
                <v-btn color="green" class="white--text" @click="createNew"
                  >Nueva colección</v-btn
                >
              </v-card-title>
              <v-card-subtitle
                >Puede crear colecciones de tiendas, para que sus clientes
                puedan acceder a todas desde un solo QR</v-card-subtitle
              >
              <v-card-text>
                <v-skeleton-loader type="paragraph" v-if="!collections" />
                <p class="mb-0 grey--text" v-else-if="!collections.length">
                  No ha creado ninguna colección
                </p>
                <div
                  class="collection-item d-flex justify-space-between align-center mb-2"
                  v-for="collection of collections"
                  :key="collection.id"
                >
                  <span class="name">{{ collection.name }}</span>
                  <v-spacer />
                  <v-btn icon
                    ><v-icon color="grey" @click="share(collection)"
                      >mdi-qrcode</v-icon
                    ></v-btn
                  >
                  <v-btn icon
                    ><v-icon color="grey" @click="edit(collection)"
                      >mdi-pencil</v-icon
                    ></v-btn
                  >
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import ICollection from '../../../interfaces/ICollection';
  import CollectionsService from '../../../api/services/collections.service';
  import NewTableModal from '../../modals/NewTableModal.vue';
  import NewCollectionModal from '../../modals/NewCollectionModal.vue';
  import { IUser } from '../../../interfaces/IUser';
  import CollectionShare from '../../modals/CollectionShare.vue';

  @Component
  export default class CollectionsPage extends Vue {
    @Prop() user: IUser;
    collectionsService = new CollectionsService();
    collections: ICollection[] = null;

    async created() {
      await this.loadCollections();
    }

    async loadCollections() {
      this.collections = null;
      this.collections = await this.collectionsService.getAll();
    }

    createNew() {
      this.$modal.show(
        NewCollectionModal,
        {
          user: this.user,
        },
        {
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          saved: () => {
            this.loadCollections();
          },
        }
      );
    }

    edit(collection: ICollection) {
      this.$modal.show(
        NewCollectionModal,
        {
          user: this.user,
          collection,
        },
        {
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          saved: () => {
            this.loadCollections();
          },
        }
      );
    }

    share(collection: ICollection) {
      this.$modal.show(
        CollectionShare,
        {
          collection,
        },
        {
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          saved: () => {
            this.loadCollections();
          },
        }
      );
    }
  }
</script>
